import './app-header.scss';
import { LogOut } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import logo from '../../assets/image/logo/updated-logo.svg';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { fetchOnboardingMe, logoutUser } from '../../services/auth';
import { clearNotification } from '../../store/action/notifications';
import { clearUserInfo, setAuthToken, setIsOnboardingCompleted } from '../../store/action/userInfo';

export default function AppHeader({ title }) {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const [userDetails, setUserDetails] = useState('');

	const fetchUserDetails = async () => {
		try {
			const data = await fetchOnboardingMe();
			setUserDetails(data);
		} catch (error) {
			toast.error('Something went wrong while fetching user details!');
		}
	};

	useEffect(() => {
		fetchUserDetails();
	}, []);

	const onLogout = async () => {
		try {
			await logoutUser();
		} catch (error) {
			console.error('Logout error:', error);
		}
		localStorage.clear();
		dispatch(clearNotification());
		dispatch(setAuthToken({ authToken: null }));
		dispatch(clearUserInfo());
		dispatch(setIsOnboardingCompleted({ isOnboardingCompleted: false }));
		navigate('/');
	};

	return (
		<div className="app-header d-none d-md-block sticky-top">
			<div className="container-fluid px-3 px-xl-5">
				<div className="app-header__inner d-flex align-items-center justify-content-between position-relative py-2">
					<div className="d-flex align-items-center">
						<img
							onClick={() => navigate('/')}
							src={logo}
							alt="logo"
							className="app-header__logo img-fluid"
						/>
					</div>

					<div className="app-header__title-wrapper position-absolute start-50 translate-middle-x text-center">
						<span className="app-header__title">{title}</span>
					</div>

					<div className="d-flex align-items-center gap-2 gap-xl-5">
						{userDetails && (
							<span className="app-header__welcome">
								<span className="app-header__username">
									Welcome! {userDetails?.data?.first_name} {userDetails?.data?.last_name}
								</span>
							</span>
						)}

						<LogOut
							onClick={onLogout}
							size={20}
							strokeWidth={2}
							className="app-header__logout-icon"
						/>
					</div>
				</div>
			</div>
		</div>
	);
}
